import { useMemo, useSyncExternalStore } from "react";
import { resolvePhotoUrl } from "../utils/profilePhoto";

const getStoredUserSnapshot = () => localStorage.getItem("user") || "";

const subscribeToStoredUser = (callback) => {
  const notify = () => {
    callback();
  };

  window.addEventListener("storage", notify);
  window.addEventListener("user-updated", notify);

  return () => {
    window.removeEventListener("storage", notify);
    window.removeEventListener("user-updated", notify);
  };
};

const parseStoredUser = (rawUser) => {
  if (!rawUser) {
    return null;
  }

  try {
    return JSON.parse(rawUser);
  } catch (error) {
    console.error("Invalid stored user:", error);
    return null;
  }
};

export const useCurrentUser = () => {
  const rawUser = useSyncExternalStore(
    subscribeToStoredUser,
    getStoredUserSnapshot,
    () => ""
  );
  const user = useMemo(() => parseStoredUser(rawUser), [rawUser]);

  return {
    user,
    avatar: resolvePhotoUrl(user?.profile_photo),
    firstName: user?.first_name || "",
    lastName: user?.last_name || "",
    fullName: [user?.first_name, user?.last_name].filter(Boolean).join(" "),
  };
};

export default useCurrentUser;
